<!--
  De qué lectura viene la cifra, dicho antes que la cifra. Un mes cerrado no vuelve a moverse aunque
  el arrendamiento sí, y sin este renglón nadie podría explicar por qué agosto no coincide con lo que
  recordaba.
-->
<div class="ca-state" *ngIf="cartera" [class.is-frozen]="cartera.closed">
  <i class="fa-solid" [ngClass]="cartera.closed ? 'fa-lock' : 'fa-wave-square'"></i>
  <span *ngIf="cartera.closed"
    ><b>{{ cartera.month }} está cerrado.</b> Esto es la fotografía que se congeló: ya no cambia aunque los arrendamientos sí.</span
  >
  <span *ngIf="!cartera.closed"
    ><b>{{ cartera.month }} está abierto.</b> Esto es la cartera viva: cambia con cada movimiento.</span
  >
</div>

<div class="ca-bar">
  <div class="ca-totals" *ngIf="cartera">
    <div class="ca-stat">
      <span class="ca-lbl">
        Cartera total
        <!--
          La cifra que más se cita de toda la pantalla y la que menos se explica sola: es la SUMA de
          las cuatro tarjetas de al lado, y cada una viene de un sitio distinto. Sin decirlo, quien
          no cuadra el total concluye que el sistema se equivocó.
        -->
        <app-ayuda-cifra titulo="De qué se compone la cartera">
          <p>Es la suma de las cuatro cifras de al lado, y cada una sale de un sitio distinto:</p>
          <ul>
            <li><b>Renta</b> — lo que falta por cobrar de las letras de la tabla de amortización, con su IVA.</li>
            <li><b>Accesorios</b> — la parte de accesorios financiados que va dentro de esas letras y sigue pendiente.</li>
            <li><b>Mora</b> — los intereses moratorios que ya están <b>en los libros</b>.</li>
            <li><b>Residual</b> — el valor residual pactado que todavía no se ha pagado.</li>
          </ul>
          <p class="ay-ojo">
            La <b>Mora</b> de aquí es el saldo registrado. Lo que se <b>cobraría hoy</b> de intereses lo calcula el devengo y va en el
            reporte de abajo: con el interruptor apagado esta dice <b>$0.00</b> y aquella no. <b>No se suman entre sí.</b>
          </p>
          <p>Cada renglón de la tabla trae su propio desglose, y la suma de los cuatro da su cartera total.</p>
        </app-ayuda-cifra>
      </span>
      <span class="ca-val">{{ cartera.totals.total | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</span>
      <span class="ca-sub">{{ cartera.totals.rows }} arrendamientos</span>
    </div>
    <div class="ca-stat">
      <span class="ca-lbl">Renta</span>
      <span class="ca-val">{{ cartera.totals.rent | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</span>
    </div>
    <!--
      Accesorios es el CUARTO componente de la cartera (ADR-0057) y faltaba: las tres tarjetas
      sumaban $31,303.58 menos que el total, sin nada en pantalla que lo explicara. Un desglose cuyas
      partes no dan el total es justo lo que esta pantalla existe para quitarle a Contabilidad.
    -->
    <div class="ca-stat">
      <span class="ca-lbl">Accesorios</span>
      <span class="ca-val">{{ cartera.totals.accessories | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</span>
    </div>
    <div class="ca-stat">
      <span class="ca-lbl">Mora</span>
      <span class="ca-val">{{ cartera.totals.mora | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</span>
    </div>
    <div class="ca-stat">
      <span class="ca-lbl">Residual</span>
      <span class="ca-val">{{ cartera.totals.residual | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</span>
    </div>
  </div>

  <div class="ca-actions">
    <!-- El filtro solo existe si hay algo que filtrar: un interruptor que nunca cambia nada es ruido. -->
    <button
      *ngIf="cuantosDescuadran > 0"
      type="button"
      class="ca-chip"
      [class.is-act]="soloDescuadres"
      (click)="soloDescuadres = !soloDescuadres"
    >
      <i class="fa-solid fa-not-equal"></i> {{ cuantosDescuadran }} no cuadran
    </button>
    <button
      *ngIf="cartera?.rows?.length"
      pButton
      type="button"
      class="p-button-sm p-button-outlined"
      icon="fa-solid fa-file-excel"
      label="Exportar"
      pTooltip="La cartera del mes con el rollforward, fila por fila"
      tooltipPosition="bottom"
      [loading]="exportando"
      (click)="exportar()"
    ></button>
    <button
      *ngIf="puedeCerrar && cartera && !cartera.closed"
      pButton
      type="button"
      class="p-button-sm"
      icon="fa-solid fa-lock"
      label="Cerrar el mes"
      (click)="abrirCierre()"
    ></button>
    <button
      *ngIf="puedeCerrar && cartera?.closed"
      pButton
      type="button"
      class="p-button-sm p-button-outlined"
      icon="fa-solid fa-lock-open"
      label="Reabrir"
      (click)="mostrarReapertura = true"
    ></button>
  </div>
</div>

<div class="ca-skeleton" *ngIf="loading">
  <p-skeleton height="2.2rem" *ngFor="let i of [1, 2, 3, 4, 5, 6]" styleClass="mb-2"></p-skeleton>
</div>

<ng-container *ngIf="!loading">
  <div class="ca-empty" *ngIf="!filas.length">
    <i class="fa-solid fa-wallet"></i>
    <p *ngIf="soloDescuadres">Todos los arrendamientos cuadran su rollforward este mes.</p>
    <p *ngIf="!soloDescuadres">No hay arrendamientos con cartera en este mes.</p>
  </div>

  <div class="ca-scroll" *ngIf="filas.length">
    <table class="ca-table">
      <thead>
        <tr>
          <th>Contrato</th>
          <th>Cliente</th>
          <!-- Las cuatro columnas del rollforward son de RENTA. Dicho aquí, la resta se puede comprobar. -->
          <th class="ca-num">Saldo inicial</th>
          <th class="ca-num">Cobrado <span class="ca-th-sub">renta</span></th>
          <th class="ca-num">Saldo final</th>
          <th class="ca-num">Mora</th>
          <th class="ca-num">Residual</th>
          <!--
            Una columna de números cuyo significado no está en ninguna parte de la pantalla. Es una
            VERIFICACIÓN, no un saldo, y su «—» no quiere decir que cuadre.
          -->
          <th class="ca-num">
            Diferencia
            <app-ayuda-cifra titulo="Qué verifica esta columna">
              <p>
                Comprueba la cuenta de toda la vida: <b>saldo inicial − cobrado = saldo final</b>. Si da cero, el mes cierra contra el
                anterior.
              </p>
              <ul>
                <li><b>Saldo inicial</b> — el saldo final que se congeló al cerrar el mes pasado.</li>
                <li><b>Cobrado</b> — lo aplicado dentro del mes, por la fecha en que <b>pagó el cliente</b>, no por la de captura.</li>
                <li><b>Saldo final</b> — lo que se debe hoy.</li>
              </ul>
              <p class="ay-ojo">
                Un <b>—</b> significa que <b>no se puede verificar</b> porque el mes anterior no se cerró. No es lo mismo que cuadrar.
              </p>
              <p>
                Las cuatro columnas son <b>de renta</b>. La mora sube por devengo sin que entre dinero y el residual se mueve por su cuenta:
                meterlos en la resta daría una diferencia que no significaría nada.
              </p>
            </app-ayuda-cifra>
          </th>
          <th>Origen</th>
        </tr>
      </thead>
      <tbody>
        <!-- El renglón abre el libro mayor: es el «de qué» detrás del total, sin entrar al expediente. -->
        <tr
          *ngFor="let f of filas"
          class="ca-clickable"
          [class.is-off]="descuadra(f)"
          (click)="verLibroMayor(f)"
          [pTooltip]="'Ver el libro mayor de ' + (f.contractNumber || f.leaseFolio)"
          tooltipPosition="top"
        >
          <td>{{ f.contractNumber || f.leaseFolio }}</td>
          <td class="ca-client">{{ f.clientName || '—' }}</td>
          <!-- Sin mes anterior cerrado NO hay saldo inicial. Un cero diría que arrancó en cero. -->
          <td class="ca-num">{{ f.opening ? (f.opening.rent | currency: 'MXN' : 'symbol-narrow' : '1.2-2') : '—' }}</td>
          <td class="ca-num">{{ cobrado(f) | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</td>
          <td class="ca-num ca-strong">{{ f.closing.rent | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</td>
          <td class="ca-num">{{ f.closing.mora | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</td>
          <td class="ca-num">{{ f.closing.residual | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</td>
          <td class="ca-num" [class.ca-off]="descuadra(f)">
            <!-- `null` es «no se puede verificar», no «cuadra». Son cosas distintas. -->
            {{ f.rollforwardDelta == null ? '—' : (f.rollforwardDelta | currency: 'MXN' : 'symbol-narrow' : '1.2-2') }}
          </td>
          <td>
            <p-tag
              [severity]="f.source === 'SNAPSHOT' ? 'info' : 'success'"
              [value]="f.source === 'SNAPSHOT' ? 'fotografía' : 'en vivo'"
            ></p-tag>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-container>

<!--
  Los intereses moratorios, arrendamiento por arrendamiento.

  Va justo debajo de la cartera y no en una pantalla aparte porque la tarjeta de MORA de arriba dice
  «$0.00» mientras el interruptor esté apagado, y ese cero se lee como «no hay mora» cuando lo que
  dice es «no se está cobrando». El reporte al lado es lo que convierte un cero mudo en una cifra
  que se puede decidir.
-->
<div class="ca-mora" *ngIf="mora && mora.rows.length">
  <!-- Fuera del toggle: un `button` dentro de otro `button` no es HTML válido. -->
  <button
    pButton
    type="button"
    class="p-button-sm p-button-text ca-mora-exp"
    icon="fa-solid fa-file-excel"
    label="Exportar"
    pTooltip="Resumen por arrendamiento y la evidencia letra por letra"
    tooltipPosition="left"
    [loading]="exportandoMora"
    (click)="exportarMora($event)"
  ></button>

  <button type="button" class="ca-mora-head" (click)="moraAbierta = !moraAbierta" [attr.aria-expanded]="moraAbierta">
    <i class="fa-solid" [ngClass]="moraAbierta ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
    <span class="ca-mora-ttl">{{ mora.moraSwitchEnabled ? 'Intereses moratorios' : 'Intereses moratorios que se cobrarían' }}</span>
    <span class="ca-mora-val">{{ mora.totals.mora | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</span>
    <span class="ca-mora-sub">
      <b>{{ mora.totals.leases }}</b> {{ mora.totals.leases === 1 ? 'arrendamiento' : 'arrendamientos' }} ·
      <b>{{ mora.totals.overduePeriods }}</b> {{ mora.totals.overduePeriods === 1 ? 'letra vencida' : 'letras vencidas' }}
      <ng-container *ngIf="mora.totals.withDefaultRate">
        · <b>{{ mora.totals.withDefaultRate }}</b> con la tasa por defecto
      </ng-container>
    </span>
    <!-- Con el interruptor apagado esto NO se está cobrando. Sin decirlo, la cifra parece un cargo vivo. -->
    <span class="ca-mora-off" *ngIf="!mora.moraSwitchEnabled">el interruptor está apagado: no se está cobrando</span>
  </button>

  <div class="ca-mora-body" *ngIf="moraAbierta">
    <ul class="ca-mora-caveats" *ngIf="mora.caveats?.length">
      <li *ngFor="let c of mora.caveats">{{ c }}</li>
    </ul>

    <div class="ca-scroll">
      <table class="ca-table">
        <thead>
          <tr>
            <th>Contrato</th>
            <th>Cliente</th>
            <th class="ca-num">Tasa mensual</th>
            <th class="ca-num">Letras vencidas</th>
            <th class="ca-num">Días de la más vieja</th>
            <th class="ca-num">Renta pendiente</th>
            <th class="ca-num">Mora</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let m of mora.rows">
            <td>{{ m.leaseFolio }}</td>
            <td class="ca-client">{{ m.clientName || '—' }}</td>
            <td class="ca-num">
              {{ m.monthlyRate * 100 | number: '1.1-2' }}%
              <!-- La tasa por defecto es un supuesto nuestro, no la del contrato: su cifra va a cambiar. -->
              <small class="ca-mora-def" *ngIf="m.usedDefaultRate">por defecto</small>
            </td>
            <td class="ca-num">{{ m.overduePeriods }}</td>
            <td class="ca-num">{{ m.maxDaysLate }}</td>
            <td class="ca-num">{{ m.totalRentPending | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</td>
            <td class="ca-num ca-strong">{{ m.totalMora | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- ── Cerrar el mes ────────────────────────────────────────────────────────────────────────── -->
<p-dialog
  [(visible)]="mostrarCierre"
  [modal]="true"
  [closable]="!cerrando"
  header="Cerrar la cartera del mes"
  styleClass="cartera-close-dialog"
  [style]="{ width: '680px' }"
>
  <div class="ca-dlg" *ngIf="cargandoPrevia">
    <p-skeleton height="1.2rem" width="60%" styleClass="mb-2"></p-skeleton>
    <p-skeleton height="4rem"></p-skeleton>
  </div>

  <!-- Sin previa hay una razón, y se dice aquí: un diálogo en blanco no se puede ni reportar. -->
  <div class="ca-dlg" *ngIf="!cargandoPrevia && !previa">
    <div class="ca-warn">
      <i class="fa-solid fa-circle-info"></i><span>{{ errorPrevia || 'No hay nada que congelar en este mes.' }}</span>
    </div>
  </div>

  <div class="ca-dlg" *ngIf="!cargandoPrevia && previa">
    <p class="ca-dlg-lead">
      Se congelará la cartera de <b>{{ previa.leases }}</b> arrendamientos de <b>{{ previa.month }}</b
      >, por <b>{{ previa.totals.total | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</b
      >.
    </p>

    <!-- Los avisos del servidor, tal cual. Incluyen el del cierre tardío, que es el que más importa. -->
    <div class="ca-warn" *ngFor="let w of previa.warnings">
      <i class="fa-solid fa-triangle-exclamation"></i><span>{{ w }}</span>
    </div>

    <div class="ca-dlg-note">
      Lo que se congela es <b>lo que la cartera dice hoy</b>. El cierre no la vuelve a calcular, y una vez cerrado el mes solo se puede
      reabrir dejando un motivo.
    </div>

    <div class="ca-dlg-delta" *ngIf="previa.withDelta.length">
      <span class="ca-lbl"
        >{{ previa.withDelta.length }} no cuadran · {{ previa.deltaTotal | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }} en total</span
      >
      <div class="ca-dlg-list">
        <span *ngFor="let d of previa.withDelta.slice(0, 12)">
          {{ d.leaseFolio }} <b>{{ d.delta | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</b>
        </span>
        <span *ngIf="previa.withDelta.length > 12">y {{ previa.withDelta.length - 12 }} más</span>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancelar" class="p-button-text" [disabled]="cerrando" (click)="mostrarCierre = false"></button>
    <button
      pButton
      type="button"
      label="Cerrar el mes"
      icon="fa-solid fa-lock"
      [loading]="cerrando"
      [disabled]="cerrando || !previa"
      (click)="confirmarCierre()"
    ></button>
  </ng-template>
</p-dialog>

<!-- ── Reabrir ─────────────────────────────────────────────────────────────────────────────── -->
<p-dialog
  [(visible)]="mostrarReapertura"
  [modal]="true"
  [closable]="!reabriendo"
  header="Reabrir el mes"
  styleClass="cartera-reopen-dialog"
  [style]="{ width: '540px' }"
>
  <div class="ca-dlg">
    <p class="ca-dlg-lead">
      Reabrir <b>{{ month }}</b> no borra nada: las fotografías quedan marcadas como reabiertas y se conservan como evidencia de lo que se
      reportó.
    </p>
    <label class="ca-lbl" for="ca-motivo">Motivo (obligatorio)</label>
    <textarea id="ca-motivo" pInputTextarea [(ngModel)]="motivo" rows="3" placeholder="Por qué hay que volver a cerrar este mes"></textarea>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Cancelar"
      class="p-button-text"
      [disabled]="reabriendo"
      (click)="mostrarReapertura = false"
    ></button>
    <button
      pButton
      type="button"
      label="Reabrir"
      icon="fa-solid fa-lock-open"
      [loading]="reabriendo"
      [disabled]="reabriendo || !motivo.trim()"
      (click)="confirmarReapertura()"
    ></button>
  </ng-template>
</p-dialog>

<app-lease-ledger-dialog></app-lease-ledger-dialog>

<p-toast position="top-right"></p-toast>
